import types from '../actions/types';

import { of } from 'rxjs';
import { ofType } from 'redux-observable';
import { switchMap, map, catchError, debounceTime } from 'rxjs/operators';
import { ajax } from 'rxjs/observable/dom/ajax';
import { fetchStickers, fetchStickersFailed } from "../actions";

function searchStickers(action) {
  const url = window.tProjectGlobals.baseUrl + '/api/stickers';
  const observable = ajax({
    url: url+ '?keyword=' + action.payload.keyword,
    method: 'GET',
    crossDomain: true,
    responseType: 'json'
  });

  return observable.pipe(
    map((res) => {
      return {
        stickers: res.response.stickers,
        keyword: action.payload.keyword
      }
    })
  );
}

export default action$ =>
  action$.pipe(
    ofType(types.SEARCH_STICKER),
    debounceTime(400),
    switchMap(action => searchStickers(action).pipe(
      map((data) => fetchStickers(data.stickers, data.keyword)),
      catchError(err => of(fetchStickersFailed(err)))
    ))
  );


// WEBPACK FOOTER //
// ./src/epics/stickers.js